import { WorkflowStepGroup } from 'app/pages/organization/testing-workflow/objects/workflow-step-group.object';
import { Action } from '@ngrx/store';
import { type } from 'services/actions-cache/actions-cache.service';
import { WorkflowPhase } from 'app/pages/organization/testing-workflow/objects/workflow-phase.object';
import { WorkflowStep } from 'app/pages/organization/testing-workflow/objects/workflow-step.object';
import { Workflow } from 'app/pages/organization/testing-workflow/objects/workflow.object';
import {
  SystemProviderWorkflowFieldsConfig,
  WorflowConfigMap,
} from 'features/testing-workflow/testing-workflow-details/testing-workflow-detais.interface';
import { TestingProviderInfo, WORKFLOW_ACTION_TYPE } from '../workflow.interface';
import { DefaultActivityType } from 'components/organization-certification/step/education/general-ce-type/activity-type-control';

export namespace ActionCreators {
  export class GetWorkflow implements Action {
    static readonly type = type<'[WORKFLOW] GET_WORKFLOW'>('[WORKFLOW] GET_WORKFLOW');
    readonly type = GetWorkflow.type;

    constructor(public payload: { workflowTypeId: number; workflowId: number }) {}
  }

  export class GetWorkflowSuccess implements Action {
    static readonly type = type<'[WORKFLOW] GET_WORKFLOW_SUCCESS'>('[WORKFLOW] GET_WORKFLOW_SUCCESS');
    readonly type = GetWorkflowSuccess.type;

    constructor(public payload: Workflow) {}
  }

  export class GetWorkflowError implements Action {
    static readonly type = type<'[WORKFLOW] GET_WORKFLOW_ERROR'>('[WORKFLOW] GET_WORKFLOW_ERROR');
    readonly type = GetWorkflowError.type;
  }

  export class Reset implements Action {
    static readonly type = type<'[WORKFLOW] RESET'>('[WORKFLOW] RESET');
    readonly type = Reset.type;
  }

  export class GetWorkflowDetailsData implements Action {
    static readonly type = type<'[WORKFLOW] GET WORKFLOW DETAILS DATA'>('[WORKFLOW] GET WORKFLOW DETAILS DATA');
    readonly type = GetWorkflowDetailsData.type;

    constructor(public payload: { workflowTypeId: number; workflowId?: number; workflowSubTypeId?: number }) {}
  }

  export class GetWorkflowConfigSuccess implements Action {
    static readonly type = type<'[WORKFLOW] GET WORKFLOW CONFIG SUCCESS'>('[WORKFLOW] GET WORKFLOW CONFIG SUCCESS');
    readonly type = GetWorkflowConfigSuccess.type;

    constructor(public payload: WorflowConfigMap) {}
  }

  export class SetWorkflowSystemProviderFieldsSuccess implements Action {
    static readonly type = type<'[WORKFLOW] GET WORKFLOW SYSTEM PROVIDER FIELDS SUCCESS'>(
      '[WORKFLOW] GET WORKFLOW SYSTEM PROVIDER FIELDS SUCCESS',
    );
    readonly type = SetWorkflowSystemProviderFieldsSuccess.type;

    constructor(public payload: SystemProviderWorkflowFieldsConfig) {}
  }

  export class SetSelectedPhase implements Action {
    static readonly type = type<'[WORKFLOW] SET_SELECTED_PHASE'>('[WORKFLOW] SET_SELECTED_PHASE');

    readonly type = SetSelectedPhase.type;

    constructor(public payload: WorkflowPhase) {}
  }

  export class UpdateSelectedPhase implements Action {
    static readonly type = type<'[WORKFLOW] UPDATE_SELECTED_PHASE'>('[WORKFLOW] UPDATE_SELECTED_PHASE');

    readonly type = UpdateSelectedPhase.type;

    constructor(public payload: WorkflowPhase) {}
  }

  export class UpdatePhase implements Action {
    static readonly type = type<'[WORKFLOW] UPDATE_PHASE'>('[WORKFLOW] UPDATE_PHASE');

    readonly type = UpdatePhase.type;

    constructor(public payload: WorkflowPhase) {}
  }

  export class UpdateWorkflow implements Action {
    static readonly type = type<'[WORKFLOW] UPDATE_WORKFLOW'>('[WORKFLOW] UPDATE_WORKFLOW');

    readonly type = UpdateWorkflow.type;

    constructor(public payload: Workflow) {}
  }

  export class SetSelectedStep implements Action {
    static readonly type = type<'[WORKFLOW] SET_SELECTED_STEP'>('[WORKFLOW] SET_SELECTED_STEP');

    readonly type = SetSelectedStep.type;

    constructor(public payload: WorkflowStep) {}
  }

  export class UpdateStep implements Action {
    static readonly type = type<'[WORKFLOW] UPDATE_STEP'>('[WORKFLOW] UPDATE_STEP');

    readonly type = UpdateStep.type;

    constructor(public payload: WorkflowStep) {}
  }

  export class RemovePhase implements Action {
    static readonly type = type<'[WORKFLOW] REMOVE_PHASE'>('[WORKFLOW] REMOVE_PHASE');

    readonly type = RemovePhase.type;

    constructor(public payload: WorkflowPhase) {}
  }

  export class SetPhases implements Action {
    static readonly type = type<'[WORKFLOW] SET_PHASES'>('[WORKFLOW] SET_PHASES');

    readonly type = SetPhases.type;

    constructor(public payload: WorkflowPhase[]) {}
  }

  export class RemoveStepGroup implements Action {
    static readonly type = type<'[WORKFLOW] REMOVE_STEP_GROUP'>('[WORKFLOW] REMOVE_STEP_GROUP');

    readonly type = RemoveStepGroup.type;

    constructor(public payload: WorkflowStepGroup) {}
  }

  export class RemoveStep implements Action {
    static readonly type = type<'[WORKFLOW] REMOVE_STEP'>('[WORKFLOW] REMOVE_STEP');

    readonly type = RemoveStep.type;

    constructor(public payload: WorkflowStep) {}
  }

  export class SetStepGroups implements Action {
    static readonly type = type<'[WORKFLOW] SET_STEP_GROUPS'>('[WORKFLOW] SET_STEP_GROUPS');

    readonly type = SetStepGroups.type;

    constructor(public payload: WorkflowStepGroup[]) {}
  }

  export class SetSteps implements Action {
    static readonly type = type<'[WORKFLOW] SET_STEPS'>('[WORKFLOW] SET_STEPS');

    readonly type = SetSteps.type;

    constructor(public payload: WorkflowStep[]) {}
  }

  export class SetDetailsMode implements Action {
    static readonly type = type<'[WORKFLOW] SET_DETAILS_MODE'>('[WORKFLOW] SET_DETAILS_MODE');

    readonly type = SetDetailsMode.type;

    constructor(public payload: boolean) {}
  }

  export class GetTestingProvider implements Action {
    static readonly type = type<'[WORKFLOW] GET_TESTING_PROVIDER'>('[WORKFLOW] GET_TESTING_PROVIDER');
    readonly type = GetTestingProvider.type;

    constructor(public payload: { testProviderId: number; updateFields: boolean }) {}
  }

  export class GetTestingProviderSuccess implements Action {
    static readonly type = type<'[WORKFLOW] GET_TESTING_PROVIDER_SUCCESS'>('[WORKFLOW] GET_TESTING_PROVIDER_SUCCESS');
    readonly type = GetTestingProviderSuccess.type;

    constructor(public payload: TestingProviderInfo) {}
  }

  export class SetIsPublishAfterImageUpload implements Action {
    static readonly type = type<'[WORKFLOW] SetIsPublishAfterImageUpload'>('[WORKFLOW] SetIsPublishAfterImageUpload');
    readonly type = SetIsPublishAfterImageUpload.type;

    constructor(public payload: boolean) {}
  }

  export class GetDefaultEducationActivities implements Action {
    static readonly type = type<'[WORKFLOW] GetDefaultEducationActivities'>('[WORKFLOW] GetDefaultEducationActivities');
    readonly type = GetDefaultEducationActivities.type;
  }

  export class GetDefaultEducationActivitiesSuccess implements Action {
    static readonly type = type<'[WORKFLOW] GetDefaultEducationActivitiesSuccess'>(
      '[WORKFLOW] GetDefaultEducationActivitiesSuccess',
    );
    readonly type = GetDefaultEducationActivitiesSuccess.type;

    constructor(public payload: DefaultActivityType[]) {}
  }

  export class GetDefaultEducationActivitiesError implements Action {
    static readonly type = type<'[WORKFLOW] GetDefaultEducationActivitiesError'>(
      '[WORKFLOW] GetDefaultEducationActivitiesError',
    );
    readonly type = GetDefaultEducationActivitiesError.type;
  }

  export class SetWorkflowAction implements Action {
    static readonly type = type<'[WORKFLOW] SET_WORKFLOW_ACTION'>('[WORKFLOW] SET_WORKFLOW_ACTION');

    readonly type = SetWorkflowAction.type;

    constructor(public payload: WORKFLOW_ACTION_TYPE) {}
  }
}

export type WorkflowActions =
  | ActionCreators.GetWorkflow
  | ActionCreators.GetWorkflowSuccess
  | ActionCreators.UpdateWorkflow
  | ActionCreators.GetWorkflowError
  | ActionCreators.Reset
  | ActionCreators.GetWorkflowDetailsData
  | ActionCreators.GetWorkflowConfigSuccess
  | ActionCreators.SetWorkflowSystemProviderFieldsSuccess
  | ActionCreators.SetSelectedPhase
  | ActionCreators.UpdateSelectedPhase
  | ActionCreators.UpdatePhase
  | ActionCreators.UpdateStep
  | ActionCreators.RemovePhase
  | ActionCreators.SetPhases
  | ActionCreators.SetSelectedStep
  | ActionCreators.RemoveStepGroup
  | ActionCreators.RemoveStep
  | ActionCreators.SetStepGroups
  | ActionCreators.SetSteps
  | ActionCreators.SetDetailsMode
  | ActionCreators.GetTestingProvider
  | ActionCreators.GetTestingProviderSuccess
  | ActionCreators.SetIsPublishAfterImageUpload
  | ActionCreators.GetDefaultEducationActivities
  | ActionCreators.GetDefaultEducationActivitiesSuccess
  | ActionCreators.GetDefaultEducationActivitiesError
  | ActionCreators.SetWorkflowAction;
